const namespaced = true;

const state = {
    integrations: [],
    organizations: [],
    devices: [],
    fetchingIntegrations: false,
    fetchingOrganizations: false,
    fetchingDevices: false,
    pendingUpload: {
        // queuing
        // upload_id_received
        // uploading
        // transfering
        // done
        // error
        status: "queuing",
        message: "",
        log: "",
    },
};

const getters = {
    integrations: (state) => state.integrations,
    organizations: (state) => state.organizations,
    devices: (state) => state.devices,
    uploadStatus: (state) => state.pendingUpload.status,
    uploadMessage: (state) => state.pendingUpload.message,
    uploadLog: (state) => state.pendingUpload.log,
    fetchingIntegrations: (state) => state.fetchingIntegrations,
    fetchingOrganizations: (state) => state.fetchingOrganizations,
    fetchingDevices: (state) => state.fetchingDevices,
};

const actions = {
    LOGIN_TO_INTEGRATION({ commit }, integrationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/integration/${integrationId}/loginurl`)
                .then((response) => {
                    window.open(response.data.url, "_blank").focus();
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    GET_INTEGRATIONS({ commit }) {
        commit("setFetchingIntegrations", true);
        return new Promise((resolve, reject) => {
            axios
                .get("/integration")
                .then((response) => {
                    commit("setOrganizations", []);
                    commit("setDevices", []);
                    commit("setIntegrations", response.data);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                })
                .finally(() => {
                    commit("setFetchingIntegrations", false);
                });
        });
    },

    GET_ORGANIZATIONS({ commit }, integrationId) {
        commit("setFetchingOrganizations", true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/integration/${integrationId}/organization`)
                .then((response) => {
                    commit("setOrganizations", response.data);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                })
                .finally(() => {
                    commit("setFetchingOrganizations", false);
                });
        });
    },

    GET_DEVICES({ commit }, { integrationId, orgId = null }) {
        commit("setFetchingDevices", true);
        return new Promise((resolve, reject) => {
            let url = "";
            if (orgId) {
                url = `/integration/${integrationId}/organization/${orgId}/device`;
            } else {
                url = `/integration/${integrationId}/device`;
            }

            axios
                .get(url)
                .then((response) => {
                    commit("setDevices", response.data);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                })
                .finally(() => {
                    commit("setFetchingDevices", false);
                });
        });
    },

    UPLOAD_FILE({ commit }, { integrationId, data }) {
        commit("setPendingUpload", {
            status: "queuing",
            message: "",
            log: "",
        });
        return new Promise((resolve, reject) => {
            axios
                .post(`/integration/${integrationId}/upload/prescription`, data)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    GET_PENDING_UPLOAD({ commit }, pendingId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/integration/pending/${pendingId}/upload`)
                .then((response) => {
                    commit("setPendingUpload", response.data);
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    RESET_RELATIONS({ commit }) {
        return new Promise((resolve, reject) => {
            commit("resetDevices");
            commit("resetOrganizations");
            resolve();
        });
    },

    LOGOUT_FROM_INTEGRATION({ commit }, integrationId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/integration/${integrationId}/logout`)
                .then(resolve)
                .catch(reject);
        });
    },
};

const mutations = {
    continueUpdateingStatus(state, pendingUpload) {
        state.pendingUpload = pendingUpload;
    },

    setIntegrations(state, integrations) {
        state.integrations = integrations;
    },

    setPendingUpload(state, pendingUpload) {
        state.pendingUpload = pendingUpload;
    },

    resetDevices(state) {
        state.devices = [];
    },

    resetOrganizations(state) {
        state.organizations = [];
    },

    setOrganizations(state, organizations) {
        state.organizations = organizations;
    },

    setDevices(state, devices) {
        state.devices = devices;
    },

    setProperty(state, { integrationId, property }) {
        let index = state.integrations.findIndex((s) => s.id === integrationId);

        if (index > 0) {
            state.integrations[index][property] = true;
        }
    },

    setFetchingIntegrations(state, fetching) {
        state.fetchingIntegrations = fetching;
    },

    setFetchingOrganizations(state, fetching) {
        state.fetchingOrganizations = fetching;
    },

    setFetchingDevices(state, fetching) {
        state.fetchingDevices = fetching;
    },
};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
